import React from 'react';


export function DisclaimerMessage({ blockName, children, }) {
  const elementName = '__message';
  const bemClass = `${blockName}${elementName}`;
  return (
    <div className={ bemClass }>
      <p className={ `${bemClass}-paragraph` }>
        { children }
      </p>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/community_disclaimer/components/disclaimerMessage.js